import actions from './actionTypes';
import * as api from '../services/api';
import {
  showVanillaLoginDialogue,
  userIdIsPresent,
  projectHasInternalContents,
  setLoadingState,
  setWebLinkSaveIdentifier
} from './fabricCanvasActions';
import * as Constants from '../utilities/constants/Constants';
import {
  getUserId,
  isWallartLiteWebLinkEdit
} from '../utilities/HelperFunctions/HelperFunctions';
import { sendPrintGA, onEditDesignGA } from '../utilities/GAHelpers/GAHelpers';
import { initiateCreateRequest } from './blockChainActions';
import {
  checkForDesignCompetition,
  checkForDesignEnterprise,
  isWestcoastAccount,
  isShippingDetailsEnabled,
  isBelgiumAccount,
  isTurkeyAccount
} from '../utilities/HelperFunctions/SignageHelperFunctions';
import { navigateToProjectWithIndex } from './actions/multiWallHandler';
import { setCurrentPageIndex } from './pageControllerActions';
import { handleTabChange } from './sideBarActions';
import { saveOnlyIfDirtyAndCall } from './projectSaveAndLoader';

export const submitProject = (projectName, installationInstruction) => (
  dispatch,
  getState
) => {
  const { project, orderFormData } = getState().finalCheck;
  const { emailAddress } = project;
  let emailId = '';
  if (emailAddress) {
    emailId = emailAddress;
  }
  const emailAddresses = emailId.split(',');

  const requestDict = {
    recipients: emailAddresses,
    name: projectName,
    print_media_name: '',
    need_install_instruction: installationInstruction ? 1 : 0,
    print_additional_instructions: orderFormData.extraInfo,
    allowSharingFotoliaCredentials: getState().modal.storeData
      .allowSharingFotoliaCredentials,
    language: getState().home.language
  };
  const requestString = JSON.stringify(requestDict);
  dispatch(sendPrintGA(project.name))
    .then(() => {
      const groupId = project.projectGroupId;
      if (groupId != null) {
        api.sendOrderPrintForm(requestString, groupId);
      } else {
        api.sendSubmitForm(requestString, project.id);
      }
    })
    .catch(() => {
      dispatch(setLoadingState(null));
    });
};

export const getOrderType = () => (dispatch, getState) => {
  let orderType;
  const designEnterprise = dispatch(checkForDesignEnterprise());
  const designCompetition = dispatch(checkForDesignCompetition());
  if (designCompetition) {
    orderType = 'design_competition';
  } else if (designEnterprise) {
    orderType = 'design_enterprise';
  } else if (getState().modal.envData.wallart_lite_external_link) {
    orderType = 'normal_external_link';
  } else {
    orderType = 'default';
  }
  return orderType;
};

export const sendShippingDetails = () => (dispatch, getState) => {
  const { orderFormData, project } = getState().finalCheck;
  let requestDict = {};
  const isWestcoast = dispatch(isWestcoastAccount());
  const isTurkey = dispatch(isTurkeyAccount());
  const isBelgium = dispatch(isBelgiumAccount());
  const isShippingEnabled = dispatch(isShippingDetailsEnabled());
  const orderType = dispatch(getOrderType());

  if (isTurkey || isBelgium) {
    requestDict = {
      shipping_details: {
        first_name: orderFormData.firstName,
        last_name: orderFormData.lastName,
        address: orderFormData.postalAddress,
        email: project.customerEmail,
        phone_number: orderFormData.phoneNumber,
        accept_terms: orderFormData.termsAndConditionState,
        share_personal_info: orderFormData.personalInformationCondition,
        share_data_to_service_provider: orderFormData.serviceProviderCondition,
        company: orderFormData.companyName,
        invoice_file: orderFormData.invoiceFile,
        turkey_order_type: orderType,
        serial: orderFormData.serialNumber
      }
    };
  } else if (isWestcoast) {
    requestDict = {
      shipping_details: {
        first_name: orderFormData.firstName,
        last_name: orderFormData.lastName,
        email: project.customerEmail,
        turkey_order_type: orderType
      }
    };
  } else if (isShippingEnabled) {
    requestDict = {
      shipping_details: {
        first_name: orderFormData.firstName,
        last_name: orderFormData.lastName,
        email: project.customerEmail,
        address: orderFormData.address,
        city: orderFormData.city,
        zip_code: orderFormData.zipCode,
        phone_number: orderFormData.phoneNumber,
        country: orderFormData.country,
        state: orderFormData.state,
        turkey_order_type: orderType
      }
    };
  }

  const requestString = JSON.stringify(requestDict);
  const requestData = `request=${requestString}`;
  api
    .sendSubmitShippingDetails(requestData, project.id)
    .then(response => {
      const responseData = response.data;
      const shippingId = responseData.data.id;

      if (response.result != 'FAILED') {
        const designEnterprise = dispatch(checkForDesignEnterprise());
        const designCompetition = dispatch(checkForDesignCompetition());
        if (
          designEnterprise ||
          designCompetition ||
          isWestcoast ||
          isShippingEnabled
        ) {
          dispatch(continueSendPrintRequest());
        } else {
          dispatch(
            sendFileUploadRequest(shippingId, orderFormData.invoiceFile)
          );
        }
      }
    })
    .catch(() => {
      dispatch(setLoadingState(null));
    });
};

export const sendFileUploadRequest = (shippingId, uploadedFile) => (
  dispatch,
  getState
) => {
  const projectId = getState().finalCheck.project.id;

  const formData = new FormData();
  formData.append('invoice_file', uploadedFile);

  api
    .uploadInvoiceData(projectId, shippingId, formData)
    .then(postResponse => {
      if (postResponse.status === 200) {
        // success
        dispatch(continueSendPrintRequest());
      } else {
        // if (postResponse.data == string.INVOICE_FILE_MISSING) {
        //   // error
        // } else {
        //   // failed save error
        // }
      }
    })
    .catch(() => {
      dispatch(setLoadingState(null));
    });
};

export const continueSendPrintRequest = () => (dispatch, getState) => {
  const { fullName } = getState().finalCheck.project;
  let name = '';
  if (fullName) {
    name = fullName;
  }
  dispatch(submitProject(name, false));
};

export const addToCart = projectName => dispatch => {
  dispatch(sendPrintGA(projectName))
    .then(() => {
      dispatch(initiateCreateRequest(() => dispatch(continueWithAddToCart())));
    })
    .catch(() => {
      dispatch(setLoadingState(null));
    });
};

export const continueWithAddToCart = () => (dispatch, getState) => {
  const { project } = getState().finalCheck;
  const { eCommerceServicesUrl } = getState().modal.storeData;
  const url = `${eCommerceServicesUrl}/projects/${project.externalId}/add_to_cart?path_info=/projects/${project.externalId}/add_to_cart`;
  const storeId = getState().modal.storeData.id;
  const requestData = JSON.stringify({
    service_url: url,
    store_id: storeId
  });

  api
    .postPerformWithData(requestData, '/api/platform_add_to_cart')
    .then(() => {
      dispatch(setLoadingState(null));
    })
    .catch(() => {
      dispatch(setLoadingState(null));
    });
};

export const finalCheckIsClicked = (callback, dispatch, getState) => {
  const isLitePartner = getState().modal.envData.is_lite_patner;
  const isVanilla = getState().modal.envData.is_vanilla_designer;
  if (getState().modal.envData.wallart_lite_web_link) {
    dispatch(setWebLinkSaveIdentifier(Constants.FINAL_CHECK_KEY));
  }
  if (!isLitePartner && isVanilla) {
    dispatch(showVanillaLoginDialogue(true));
  } else {
    dispatch(saveOnlyIfDirtyAndCall()).then(() => {
      dispatch(callback());
    });
  }
};

export const onEditDesign = setCurrentPageIndexFunction => dispatch => {
  setCurrentPageIndexFunction(Constants.DESIGN_PAGE);
  dispatch(onEditDesignGA());
};

export const handleLoader = () => dispatch => {
  dispatch({
    type: actions.LOADER_ON_ADD_TO_ORDER
  });
};

export const getRequestForQuotation = () => (dispatch, getState) => {
  let requestForQuotation;
  const requestForQuotationFromEnvironment = getState().modal.envData
    .request_for_quotation;
  if (getState().modal.storeData.supportedProducts.length > 0) {
    requestForQuotation =
      getState().modal.storeData.requestForQuotation ||
      (getState().modal.envData.wallart_lite_external_link &&
        requestForQuotationFromEnvironment);
  } else {
    requestForQuotation = requestForQuotationFromEnvironment;
  }
  return requestForQuotation;
};

export const canDisplayTemplateFolderPath = getState =>
  isTemplateEdit(getState) && isTemplate(getState);

export const isTemplate = getState =>
  getState().modal.envData.template_designer;

export const isTemplateEdit = getState => {
  const templatesState = getState().finalCheck.project.state;
  return templatesState === Constants.TEMPLATE_STATE;
};

export const isInspirationDesigner = getState =>
  isInspiration(getState) || isInspirationProject(getState);

export const isInspiration = getState =>
  getState().modal.envData.inspiration_designer;

export const isInspirationProject = getState => {
  const inspirationState = getState().finalCheck.project.state;
  return inspirationState === Constants.INSPIRATION_STATE;
};

export const updateFinalCheckWithData = responseData => dispatch => {
  const formData = {
    firstName: responseData.first_name,
    lastName: responseData.last_name,
    phoneNumber: responseData.phone_number,
    postalAddress: responseData.address,
    termsAndConditionState: responseData.accept_terms,
    personalInformationCondition: responseData.share_personal_info,
    serviceProviderCondition: responseData.share_data_to_service_provider
  };
  dispatch({
    type: actions.SET_ORDER_FORM_DETAILS,
    payload: {
      formData
    }
  });
  dispatch(setCustomerEmail(responseData.email));
};

export const actionInspirationRedirect = projectName => (
  dispatch,
  getState
) => {
  dispatch(sendPrintGA(projectName))
    .then(() => {
      let urlString = null;
      const redirectUrl = getState().modal.envData.redirect_url_on_load_error;
      urlString = `${redirectUrl}/partner/inspirations`;
      if (urlString) {
        window.location = urlString;
      }
    })
    .catch(() => {
      dispatch(setLoadingState(null));
    });
};

export const changeMinimumViewingDistance = distance => (
  dispatch,
  getState
) => {
  getState().finalCheck.project.targetViewingDistance = distance;
};

export const actionTemplateRedirect = projectName => (dispatch, getState) => {
  dispatch(sendPrintGA(projectName))
    .then(() => {
      let urlString = null;
      const redirectUrl = getState().modal.envData.redirect_url_on_load_error;
      const { envData } = getState().modal;
      if (envData.account_id && envData.retailer_signed_in) {
        urlString = `${redirectUrl}/accounts/spaces`;
      } else if (envData.partner_signed_in) {
        urlString = `${redirectUrl}/partner/templates`;
      }
      if (urlString) {
        window.location = urlString;
      }
    })
    .catch(() => {});
};

export const editMaterialIsClicked = projectIndex => dispatch => {
  dispatch(setCurrentPageIndex(Constants.DESIGN_PAGE));
  if (projectIndex >= 0) {
    dispatch(navigateToProjectWithIndex(projectIndex));
  }
  dispatch(handleTabChange(Constants.MATERIAL_TAB_KEY));
};

export const setFormDetailsInProject = formElements => dispatch => {
  const formData = {};
  formElements.forEach(formElement => {
    switch (formElement.id) {
      case Constants.ORDER_DETAILS_FORM.PROJECT_NAME:
        dispatch(setProjectName(formElement.value));
        break;
      case Constants.ORDER_DETAILS_FORM.FIRST_NAME:
        formData.firstName = formElement.value;
        break;
      case Constants.ORDER_DETAILS_FORM.LAST_NAME:
        formData.lastName = formElement.value;
        break;
      case Constants.ORDER_DETAILS_FORM.ADDRESS:
        formData.address = formElement.value;
        break;
      case Constants.ORDER_DETAILS_FORM.CITY:
        formData.city = formElement.value;
        break;
      case Constants.ORDER_DETAILS_FORM.COUNTRY:
        formData.country = formElement.value;
        break;
      case Constants.ORDER_DETAILS_FORM.STATE:
        formData.state = formElement.value;
        break;
      case Constants.ORDER_DETAILS_FORM.ZIP_CODE:
        formData.zipCode = formElement.value;
        break;
      case Constants.ORDER_DETAILS_FORM.PHONE_NUMBER:
        formData.phoneNumber = formElement.value;
        break;
      case Constants.ORDER_DETAILS_FORM.CUSTOMER_NAME:
        dispatch(setCustomerName(formElement.value));
        break;
      case Constants.ORDER_DETAILS_FORM.CUSTOMER_EMAIL:
        dispatch(setCustomerEmail(formElement.value));
        break;
      case Constants.ORDER_DETAILS_FORM.COMPANY_NAME:
        formData.companyName = formElement.value;
        break;
      case Constants.ORDER_DETAILS_FORM.POSTAL_ADDRESS:
        formData.postalAddress = formElement.value;
        break;
      case Constants.ORDER_DETAILS_FORM.INVOICE:
        formData.invoiceFile = formElement.value;
        break;
      case Constants.ORDER_DETAILS_FORM.SERIAL_NUMBER:
        formData.serialNumber = formElement.value;
        break;
      case Constants.ORDER_DETAILS_FORM.EXTRA_INFO:
        formData.extraInfo = formElement.value;
        break;
      case Constants.ORDER_DETAILS_FORM.INSTRUCTION:
        formData.sendInstallationInstruction = formElement.value;
        break;
      case Constants.ORDER_DETAILS_FORM.TERMS_AND_CONDITIONS:
        formData.termsAndConditionState = formElement.value;
        break;
      case Constants.ORDER_DETAILS_FORM.PERSONAL_INFORMATION_CONDITION:
        formData.personalInformationCondition = formElement.value;
        break;
      case Constants.ORDER_DETAILS_FORM.SERVICE_PROVIDER_CONDITION:
        formData.serviceProviderCondition = formElement.value;
        break;
      default:
        break;
    }
  });
  dispatch({
    type: actions.SET_ORDER_FORM_DETAILS,
    payload: {
      formData
    }
  });
};

export const setProjectName = value => (dispatch, getState) => {
  getState().finalCheck.project.name = value;
};

export const setCustomerName = value => (dispatch, getState) => {
  getState().finalCheck.project.customerName = value;
};

export const setCustomerEmail = email => (dispatch, getState) => {
  getState().finalCheck.project.customerEmail = email;
};

export const setExternalUserId = () => (dispatch, getState) => {
  const platformFlow = getState().modal.envData.platform_flow;
  if (platformFlow) {
    dispatch(
      userIdIsPresent(userId => {
        getState().finalCheck.project.externalUserId = userId;
      })
    );
  } else {
    getState().finalCheck.project.externalUserId = getUserId();
  }
};

export const setExternalLink = () => (dispatch, getState) => {
  const isExternalLink = getState().modal.envData.wallart_lite_external_link;
  getState().finalCheck.project.externalLink = isExternalLink;
};

export const setApplicationGroupId = () => (dispatch, getState) => {
  const applicationGroupId = getState().modal.envData.application_group_id;
  getState().finalCheck.project.applicationGroupId = applicationGroupId;
};

export const setExternalContent = () => (dispatch, getState) => {
  const hasInternalContent = dispatch(projectHasInternalContents());
  const hasExternalContent = hasInternalContent
    ? false
    : getState().modal.envData.wallart_lite_external_content;
  getState().finalCheck.project.externalContent = hasExternalContent;
};

export const setWebLink = () => (dispatch, getState) => {
  const isWebLink = getState().modal.envData.wallart_lite_web_link;
  const isWebLinkEdit = isWallartLiteWebLinkEdit();
  if (isWebLink || isWebLinkEdit) {
    getState().finalCheck.project.webLink = true;
  } else {
    getState().finalCheck.project.webLink = false;
  }
};

export const setAccountId = () => (dispatch, getState) => {
  const accountId = getState().modal.envData.account_id;
  if (accountId != null) {
    getState().finalCheck.project.accountId = accountId;
  }
};

export const setGaUserId = id => (dispatch, getState) => {
  getState().finalCheck.project.gaUid = id;
  getState().finalCheck.project.gaCid = id;
};

export const setCanvasTileType = val => (dispatch, getState) => {
  getState().finalCheck.project.canvasTileType = val;
};
